import { createContext as o } from "react";
var r = /*#__PURE__*/o(void 0);
export { r as RUMContext };